export default {
  UPDATE_KIT_SKUS(state, payload) {
    state.skus = payload;
  },

  UPDATE_KIT_SUMMARY(state, payload) {
    state.kitSummary = payload;
  },

  SET_KIT_SKUS(state, payload) {
    state.skus = payload;
  },

  UPDATE_KIT_TOTAL_SUGGESTED_RETAIL_PRICE(state, payload) {
    state.totalSuggestedRetailPrice = payload;
  },

  UPDATE_KIT_TOTAL_COGS(state, payload) {
    state.totalCOGS = payload;
  },

  UPDATE_KIT_FINAL_RETAIL_PRICE(state, payload) {
    state.finalRetailPrice = payload;
  },

  UPDATE_KIT_PERCENT_MARGIN(state, payload) {
    state.percentMargin = payload;
  },

  UPDATE_KIT_SHIP_METHOD(state, payload) {
    state.shipMethod = payload;
    state.newKit.shipMethod = payload;
  },
  UPDATE_KIT_PACKAGING(state, payload) {
    state.packaging = payload;
    state.newKit.packaging = payload;
  },
  UPDATE_NEW_KIT_SKUS(state, payload) {
    state.newKit.skus = payload;
  },
  UPDATE_NEW_KIT_SKU(state, payload) {
    state.newKit.sku = payload;
  },
  UPDATE_NEW_PRODUCT_NAME(state, payload) {
    state.newKit.sku = payload;
  },
  UPDATE_PRODUCT_TO_EDIT(state, payload) {
    state.productToEdit = payload;
  },
  SET_CLONED_KIT_SKU(state, payload) {
    state.clonedKitSku = payload;
  },
  setQuickEditActive(state, isActive) {
    state.quickEditActive = isActive;
  },
};
